import React, { Component } from 'react';
import { SortableElement } from 'react-sortable-hoc';
import _ from 'lodash';
import { Row, Col, Tooltip, OverlayTrigger, Checkbox } from 'react-bootstrap';
import classNames from 'classnames';
import FaBars from 'react-icons/lib/fa/bars';
import config from '../../../../config';
const sellerInventoryOwnershipMap = {
  SellerConsigned: 'sellers',
  PartnerConsigned: '3PL partners',
  PartnerPurchased: 'GBG inventory sellers',
};

export const GBGProductQualityCheckItem = SortableElement(({ props, item, itemIndex, baseQualityCheck }) => {
  const {
    QualityChecksToInclude = [],
    QualityChecksToExclude = [],
    qualityChecksMatchingParams = {},
  } = props.currentRecord;

  const itemToInclude = QualityChecksToInclude.find((itemToInclude) => {
    return itemToInclude.value == item.ItemNumber;
  });
  const matchingRules = prepareMatchingRules(item, qualityChecksMatchingParams);

  const itemToExclude = QualityChecksToExclude.find((itemToExclude) => {
    return itemToExclude.value == item.ItemNumber;
  });
  return (
    <Row key={itemIndex} >
      <FaBars style={{width:50, height:25, color:'#a09d9d', cursor:'grab'}} className="top9 pull-left pleft15 top2"></FaBars>
      {item.ItemNumber && !baseQualityCheck && (
        <Col  className="pull-left left10  top2">
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip className="in" id="tooltip-top">
                {itemToExclude ? 'Remove from excluded' : 'Exclude'}
              </Tooltip>
            }
          >
            <Checkbox
              data-testid="exclude-item-checkbox"
              onChange={() => {
                onItemSelect({ itemToExclude, itemToInclude, item, props });
              }}
              checked={itemToExclude ? true : false}
            ></Checkbox>
          </OverlayTrigger>
        </Col>
      )}
      <Col
        xs={10}
        data-testid="quality-check-item-box"
        style={itemToExclude ? {cursor:'grab',  'text-decoration': 'line-through' } : {cursor:'grab'}}
        className={classNames(
          'top12 bot15 pleft10',
          { green: itemToInclude },
          { left20: !item.ItemNumber },
          { pleft20: !item.ItemNumber },
          { red: itemToExclude }
        )}
      >
        {baseQualityCheck ? (
          <div data-testid="base-quality-check-element" className="cyen text-bold left25 pleft5">
            Base Quality Checks
          </div>
        ) : (
          <div>
            {item.Text}
            {item.ItemNumber ? (
              <span
                className="left10 orange font-size-16 cursor-pointer underlineText"
                onClick={() => {
                  const serverURL =
                    config.getEnvironmentName() == 'local'
                      ? config.getEnvironment().clientSideURL
                      : config.getEnvironment().directServerBaseURL;
                  const link = `${serverURL}/admin/quality-checks?ItemNumbers=${encodeURIComponent(
                    item.ItemNumber
                  )}&openEditForm=true`;
                  window.open(link, '_blank');
                }}
              >{`#${item.ItemNumber}`}</span>
            ) : (
              <span data-testid="quality-check-additional-text" className="orange">
                {' only for this GBG Product'}
              </span>
            )}
            {['Donation', 'Show First'].includes(item.qualityCheckType) && (
              <span style={{ color: '#62c5f7' }} className="left5">
                {item.qualityCheckType}
              </span>
            )}
          </div>
        )}

        {matchingRules.map((rule, index) => {

          return (
            <div  data-testid="matching-rule-box" className="top5 purple" key={index}>
              &#8226; {rule.Text}
             </div>
          );
        })}
      </Col>
      {!baseQualityCheck && props.currentRecord._id && props.displayContentForQualityCheck(item)}
    </Row>
  );
});

function onItemSelect({ itemToExclude, itemToInclude, item, props }) {
  let dataToUpdate = {};
  const { QualityChecksToInclude = [], QualityChecksToExclude = [] } = props.currentRecord;

  if (itemToExclude) {
    const foundIndex = QualityChecksToExclude.findIndex((obj) => {
      return obj.value == itemToExclude.value;
    });

    if (foundIndex !== -1) {
      dataToUpdate.QualityChecksToExclude = [
        ...QualityChecksToExclude.slice(0, foundIndex),
        ...QualityChecksToExclude.slice(foundIndex + 1),
      ];
    }
  } else {
    dataToUpdate.QualityChecksToExclude = QualityChecksToExclude.concat([
      {
        value: item.ItemNumber,
        label: item.Text,
      },
    ]);

    if (itemToInclude) {
      const foundIndex = QualityChecksToInclude.findIndex((obj) => {
        return obj.value == itemToInclude.value;
      });

      if (foundIndex !== -1) {
        dataToUpdate.QualityChecksToInclude = [
          ...QualityChecksToInclude.slice(0, foundIndex),
          ...QualityChecksToInclude.slice(foundIndex + 1),
        ];
      }
    }
  }

  props.updateParentComponentState({
    currentRecord: {
      ...props.currentRecord,
      ...dataToUpdate,
    },
  });
}

function prepareMatchingRules(item, qualityChecksMatchingParams) {
  const { CategoryTags: categoryTagsInParams = [], Categories: categoriesInParams = [] } = qualityChecksMatchingParams;
  const {
    CategoryTags = [],
    Categories = [],
    Models = [],
    OverrideMatchingConditions = [],
    SellerInventoryOwnership = [],
  } = item;
  let matchingRules = _.intersection(CategoryTags, categoryTagsInParams).map((tag) => {
    return { Text: 'Category Tag = ' + tag };
  });
  categoriesInParams.forEach((categoryData) => {
    if (Categories.length) {
      Categories.forEach((qualityCheckCategoryData) => {
        if (qualityCheckCategoryData.Category == categoryData.Category) {
          if (qualityCheckCategoryData.Subcategory) {
            if (categoryData.Subcategory) {
              if (categoryData.Subcategory == qualityCheckCategoryData.Subcategory) {
                matchingRules.push({
                  Text: `Category and Subcategory =  ${categoryData.Category} and ${categoryData.Subcategory}`,
                });
              }
            }
            /* if there is no Subcategory to check in parameters, we do not match items with Subcategories, even if Category matches */
          } else {
            matchingRules.push({ Text: `Category =  ${categoryData.Category}` });
            /* if there is no Subcategory in quality check item, it is matched only by Category */
          }
        }
      });
    }
  });

  if (qualityChecksMatchingParams.Brand) {
    if (Models.length) {
      Models.forEach((qualityCheckModelData) => {
        if (qualityCheckModelData.Brand == qualityChecksMatchingParams.Brand) {
          if (qualityCheckModelData.Model) {
            if (qualityChecksMatchingParams.Model) {
              if (qualityChecksMatchingParams.Model == qualityCheckModelData.Model) {
                matchingRules.push({
                  Text: `Brand and Model = ${qualityCheckModelData.Brand} and ${qualityCheckModelData.Model}`,
                });
              }
            } else {
              matchingRules.push({ Text: `Brand = ${qualityCheckModelData.Brand}` });
              /* if there is no Model to check, we match all quality check only by a Brand */
            }
          } else {
            matchingRules.push({ Text: `Brand = ${qualityCheckModelData.Brand}` });
            /* if there is no Model in quality check item, it is matched only by Brand */
          }
        }
      });
    }
  }

  const { Type } = OverrideMatchingConditions[0] || {};

  if (SellerInventoryOwnership.length) {
    const sellerTypes = SellerInventoryOwnership.map((sellerType) => {
      return sellerInventoryOwnershipMap[sellerType];
    });

    if(Type == 'SellerInventoryOwnership') {
      matchingRules.push({Text: `It is always displayed for ${sellerTypes.join(', ')}`});
    }else{
      matchingRules.push({Text: `Displayed only for ${sellerTypes.join(', ')}` });
    }
  }

  return matchingRules;
}
